import { render, staticRenderFns } from "./IftttAdd.vue?vue&type=template&id=452d4722&scoped=true"
import script from "./IftttAdd.vue?vue&type=script&lang=js"
export * from "./IftttAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452d4722",
  null
  
)

export default component.exports